import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CashierResponse } from '../models/cashier.model';

@Injectable({
  providedIn: 'root'
})
export class CashierService {
  private url = environment.api;
  constructor(
    private http: HttpClient
  ) { }

  getCashiers() {
    return this.http.get(this.url + "api/erp/bank/cashs");
  }

  deleteCashier(idCashier: number) {
    return this.http.delete(this.url + "api/erp/bank/cash/" + idCashier);
  }

  postCashier(newCashier: CashierResponse) {
    return this.http.post(this.url + "api/erp/bank/cash", newCashier);
  }

  updateCategory(updatedCashier: CashierResponse) {
    return this.http.put(this.url + "api/erp/bank/cash/" + updatedCashier.id, updatedCashier);
  }

  getCashiersByClient(clue: string) {
    return this.http.get(this.url + "api/role/permissions/warehouse/cash", {
      params: {
        clue: clue
      }
    });
  }

  getCashiersByClue(clue: string) {
    return this.http.get(this.url + "api/erp/sale/invoices/cash/search", {
      params: {
        clue: clue
      }
    });
  }

  getCashsById(id:any) {
    return this.http.get(this.url + "api/erp/bank/cash/" + id);
  }
}
